export default {
  title: 'Controle de acesso',
  recoveryButton: 'Recuperar senha',
  newLink: 'Registrar nova empresa',
  oldVersion: 'Acesso à versão clássica do módulo web de efatura',
  help: 'Se precisar de ajuda acesse ',
  usermanual: 'manual do usuário',
  subtitle1: 'Se for fornecedor, através do nosso serviço pode realizar as seguintes operações:',
  text1: 'Emitir faturas e enviá-las aos seus clientes',
  text2: 'Consultar o estado das faturas por parte do seu cliente',
  subtitle2: 'Como cliente, através do nosso serviço, pode realizar as seguintes operações:',
  text3: 'Acessar as faturas emitidas pelos seus fornecedores',
  text4: 'Aceitar ou recusar as faturas recebidas',
  text5: 'Armazenar eletronicamente as faturas emitidas durante o período legal.',
  text6: 'Recuperar uma duplicata de qualquer fatura armazenada',
  button: 'Login',
  access: 'Acessar plataforma',
  howItWorks: 'Assim funciona o Sistema eFactura',
  news: 'Novidades e notícias',
  user: 'Usuário:',
  password: 'Senha:',
  nif: 'NIF/CIF/NIE/Outro:',
  removeOldVersion: 'A versão clássica deixará de estar operativa no dia 15/11/2022',
  validate: {
    user: 'usuário',
    password: 'senha',
    nif: 'nif'
  },
  contract: {
    text: 'Se deseja contratar os nossos serviços entre em contato',
    link: 'soporte.sistemaefactura@unifiedpost.com'
  },
  recovery: {
    title: 'Recuperar senha',
    user: 'Usuário',
    nif: 'NIF/CIF/NIE/Outro',
    email: 'Email',
    button: 'Enviar senha',
    ok: 'Senha enviada para o email do usuário'
  },
  temporalToken: {
    activeOk: 'A sua conta foi ativada corretamente'
  },
  resetpasswd: {
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    restaurar: 'Restaurar',
    caracteresMinimos: 'Mínimo de 6 caracteres',
    ok: 'senha alterada corretamente'
  },
  registry: {
    title: 'Registrar nova empresa',
    companyData: 'Dados da empresa',
    nif: 'NIF',
    reason: 'Razão Social',
    address: 'Endereço',
    addressPlaceholder: 'R\\',
    zipCodePlaceholder: 'C.P.',
    townPlaceholder: 'Localidade',
    cityPlaceholder: 'Cidade',
    countryPlaceholder: 'País',
    email: 'Email',
    phone: 'Telefone',
    accessData: 'Dados de acesso',
    user: 'Usuário',
    pass: 'senha',
    rePass: 'Repetir senha',
    repeatEmail: 'Repetir Email',
    buttonRegistry: 'Registrar',
    buttonCancelRegistry: 'Cancelar',
    acceptConditions: 'Aceito os termos e condições...',
    captcha: 'captcha',
    validate: 'Validar',
    companyAlrealdyExists: 'A empresa já está registrada, se precisar de ajuda para acessar, entre em contato com o nosso suporte ',
    informaError: 'Não foi possível recuperar os dados do NIF indicado. Por favor, entre em contato com a nossa equipe de suporte em: ',
    seeTerms: 'Ver termos e condições',
    modal: {
      title: 'Registro completo',
      text: 'Desfrute do nosso serviço',
      button: 'Aceitar'
    },
    errors: {
      5000: 'Ocorreu um erro inesperado.',
      5001: 'Para se registrar no sistema, é necessário informar uma conta de email corporativa.',
      5002: 'Ocorreu um erro ao enviar o email de ativação de conta, por favor entre em contato com a nossa equipe de suporte ',
      5003: 'Ocorreu um erro ao criar o novo usuário.',
      5004: 'Ocorreu um erro ao buscar o usuário.',
      5005: 'Ocorreu um erro ao registrar a empresa no sistema principal.',
      5006: 'Ocorreu um erro ao atualizar o usuário.',
      5007: 'Não foi possível registrar o usuário indicado, tente inserir outro.'
    }
  },
  sesion: {
    error: 'Sessão expirada',
    bankiaError: 'Erro de conexão. Código: ',
    longError: 'Sua sessão expirou, você será redirecionado para a página de acesso',
    user_pass_invalid: 'Usuário ou senha incorretos',
    user_pass_invalid_jcyl: 'Usuário ou senha incorretos. Se não se lembra da sua senha, envie um email para <a href="mailto:igacyl.factura@jcyl.es">igacyl.factura@jcyl.es</a>.',
    error_cas: {
      401: 'Ocorreu um erro de acesso ao sistema. Caso o erro persista, por favor entre em contato com o Serviço de Atendimento ao Usuário',
      4011: 'Acesso não autorizado. O usuário deve se registrar na plataforma de Faturamento Eletrônico do Governo de La Rioja. <a href="https://web.larioja.org/portal-facturacion-e" target="_blank" style="color:#695596 !important;">https://web.larioja.org/portal-facturacion-e</a>'
    },
    inactive_user: 'O usuário está desabilitado temporariamente, entre em contato com a equipe de suporte através do email ',
    inactive_user_jcyl: 'O usuário está desabilitado temporariamente, entre em contato por email com ',
    blocked_user: 'Seu usuário está bloqueado, para desbloqueá-lo, clique no seguinte link: <a href="/recovery" style="color:#695596 !important;">recuperar senha</a>.',
    blocked_user_jcyl: 'Seu usuário está bloqueado, entre em contato por email com ',
    service_not_avaible: 'Serviço indisponível',
    service_not_avaible_jcyl: 'Serviço indisponível',
    expire: {
      title: 'Sua sessão está prestes a expirar',
      description: 'Sua sessão vai expirar em {0} minutos'
    }
  },
  eurobits: {
    title1: 'Envie suas faturas em formato eletrônico',
    title2: 'Receba suas faturas em formato eletrônico',
    title3: 'Avisos por mudanças de estado em suas faturas',
    title4: 'Interconexão com outras plataformas',
    text1: 'Você pode criar suas faturas online, importá-las ou integrá-las diretamente do seu ERP.',
    text2: 'Você pode receber faturas de seus fornecedores em qualquer formato e gerenciá-las online ou a partir do seu ERP.',
    text3: 'Sistema de avisos que enviará um email quando suas faturas mudarem de estado.',
    text4: 'Nossa plataforma está conectada com outras como (FACe, BiscayTIK, AOC, etc.).'
  },
  verifactuNotification: {
    title: 'Informação sobre VERI*FACTU',
    message: 'Bem-vindo à plataforma.',
    defaultOption: 'A opção padrão é "Não Verifactu".',
    instructions: 'Se deseja ativar a opção "Verifactu", deve ir a <strong>Configuração → Dados Gerais</strong> e modificar a configuração correspondente.',
    accept: 'Aceitar',
    doNotShowAgain: 'Não mostrar esta mensagem novamente'
  }
}
